import React from 'react';

import Link from '../../../../library/link/link';

import { Maybe } from '../../../../shared/types/graphql-types';

import './product-brand-logo.scss';

interface ProductBrandLogoProps {
  brand: Maybe<string> | undefined;
  brandLogoUrl: string;
  className?: string;
  link?: string;
}

function ProductBrandLogo(props: ProductBrandLogoProps) {
  const { brand, brandLogoUrl, className = '', link } = props;

  if (brandLogoUrl) {
    return link ? (
      <Link className={`${className || ''} product-brand-logo`} to={link}>
        <img
          alt={`${brand} Logo`}
          aria-label={`${brand} Logo`}
          src={brandLogoUrl}
          styleName="brand-logo"
        />
      </Link>
    ) : (
      <img
        alt={`${brand} Logo`}
        aria-label={`${brand} Logo`}
        className={`${className || ''} product-brand-logo`}
        src={brandLogoUrl}
        styleName="brand-logo"
      />
    );
  } else {
    return null;
  }
}

export default ProductBrandLogo;
